import React, { useEffect, useRef } from "react";

const useOnClickOutside = (ref, onClickOutside) => {
  useEffect(() => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside();
      }
    };
    onClickOutside && document.addEventListener("mousedown", handleClickOutside);
    return () => {
      onClickOutside && document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onClickOutside]);
};

export default function ContainerCard({
  children,
  className,
  style,
  onTouchStart,
  onTouchMove,
  dataAttrs,
  onTouchEnd,
  onClickOutside
}) {
  const wrapperRef = useRef(null);
  useOnClickOutside(wrapperRef, onClickOutside);
  return (
    <div
      ref={wrapperRef}
      {...dataAttrs}
      className={`containerCard ${className || ""}`}
      style={style}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}>
      {children}
    </div>
  );
}
